import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import autoBind from 'react-autobind';

import gql from 'graphql-tag';
import { resultHasErrors } from 'utils/graphql-errors';

class ThinkificSSO extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  async getTokenSSO() {
    const { client } = this.props;

    try {
      const result = await client.mutate({
        mutation: gql`
          mutation generateThinkificSSO {
            generateThinkificSSO
          }
        `,
      });

      const { data, errors } = result;

      if (resultHasErrors({ errors })) {
        alert('Something went wrong');
      } else {
        const { generateThinkificSSO } = data || {};
        window.open(generateThinkificSSO, '_blank');
      }
    } catch (error) {
      console.log(error);
    }
  }
  render() {
    return (
      <div onClick={() => this.getTokenSSO()} style={{ fontFamily: 'Poppins Medium' }}>
        <FormattedMessage id="app.layout.header.thinkific" defaultMessage="Course Content" />
      </div>
    );
  }
}

export default withRouter(withApollo(injectIntl(ThinkificSSO)));



// WEBPACK FOOTER //
// ./src/ui/app/layout/header/thinkific-sso.js